import styled from "styled-components"

export const RewarDocumentsContainer = styled.div`
display:flex;
justify-content:space-between;
width:100%;

.icons-container{
    display:flex;
    align-items:center;
}

.icons{
    padding:16px;
    cursor:pointer;
}
`

export const UploadDocumentContainer = styled.div`

.middle-section {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .text{
    margin-left:8px;
  }

  .doc-container{
  border-radius: 4px;
border: 1px solid var(--Crimson-Blush-500, #DA6C74);
padding:12px;
display:flex;
justify-content:space-between;
align-items:center;
}

.doc-text{
  color: #184A61;
font-family: Lato;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 20px;
width: 85%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

}

.delete-icon{
  cursor:pointer;
}

  .title {
    font-size: 18px;
    color: #005c87;
    margin-bottom: 10px;
    font-weight: bold;
  }

  #event-upload-file {
    display: none;
  }

  .custom-upload-button {
    width: 100%;
    display: flex;
    ${'' /* flex-direction: row-reverse; */}
    align-items: center;
    height: 48px;
    background-color: #FFFFFF;
    border: 1px solid #DA6C74;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    justify-content: center;

    color: #184A61;
font-family: Lato;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 20px; 
  }


  .custom-upload-button svg {
    width: 24px;
    height: 24px;
    margin-left: 10px;
  }

`



